import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { getParty } from "@/lib/api";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Details } from "@/components/Details";
import { Rules } from "@/components/Rules";
import { Board } from "@/components/Board";
import { RsvpSection } from "@/components/RsvpSection";
import { Footer } from "@/components/Footer";
import { ScrollBackdrop } from "@/components/ScrollBackdrop";
import { PhotoStrip } from "@/components/PhotoStrip";
import { TastingBallot } from "@/components/TastingBallot";
import { LabelMaker } from "@/components/LabelMaker";
import VotePage from "@/components/VotePage";
import HostQR from "@/components/HostQR";

const Home = ({ party }) => (
  <>
    <Hero party={party} />
    <Marquee />
    <Details party={party} />
    <Rules />
    <LabelMaker />
    <PhotoStrip />
    <Board />
    <TastingBallot party={party} />
    <RsvpSection party={party} />
    <Footer party={party} />
  </>
);

function App() {
  const [party, setParty] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    getParty().then(setParty).catch(() => {});
  }, []);

  return (
    <div className="App bg-ink text-cream font-body">
      <div className="noise-overlay" />
      <ScrollBackdrop />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#FBF4E6",
            border: "1px solid #2E4028",
            color: "#26201A",
            fontFamily: "'Jost', sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home party={party} />} />
          <Route path="/vote/:soup" element={<VotePage />} />
          <Route path="/host" element={<HostQR />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
